import React, { memo } from 'react';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { areProductPropsEqual } from '../utils';
import styles from './eaches-column.module.less';

type Props = import('../../../types').ColumnProps;

const Column = ({ value }: Props) => {
  const { product } = value;

  if (product.uomId == null) {
    return null;
  }

  const eaches = product.eaches ?? 1;
  const total = product.quantity * eaches;

  return (
    <FlexColumn>
      <Text className={styles.total} element='span' textType={TextType.Paragraph} value={String(total)} />
      <Text className={styles.formula} element='span' textType={TextType.Caption} value={`(${product.quantity}×${eaches})`} />
    </FlexColumn>
  );
};

const areEqual = (prev: Props, next: Props) =>
  areProductPropsEqual('eaches')(prev, next) && prev.value.product.quantity === next.value.product.quantity;

export const EachesColumn = memo(Column, areEqual);
